// ---- Courses screen meta steps
export const CoursesMetaStep = {
    COURSES: "courses",
    FLASH: "flash",
    EXERCISER: "exerciser"
}